export function setUniqueId(): number {
  return Date.now() * Math.random()
};